import { Outlet, useNavigate } from 'react-router-dom';
import { Header } from '@/components/header';
import GeofenceBanner from '../header/geofence-banner';
import useGeofenceCheck from '@/utils/geofence-check';
import ErrorBoundary from '@/app/error-boundary';
import { useAccurateTimeCheck } from '@/hooks';
import { useAccountStore } from '@/store/use-account-store';
import { useEffect, useState } from 'react';
import { ErrorCode, WsErrorCode } from '@/types';
import { useWebSocketStore } from '@/store/use-websocket-store';
import { logConsole } from '@/lib/utils';
import { useListenKey } from '@/lib/api/listen-key';
import RealtimeConnectionLostBanner from '../header/realtime-connection-lost-banner';
import AnnouncementBanner from '../header/announcement-banner';
import { Button } from '../ui';

export default function RootLayout() {
  const { data: isSanctioned } = useGeofenceCheck();
  const { isAccurate: isSystemClockAccurate, offset } = useAccurateTimeCheck();
  const { hasAuth, setTimeOffset } = useAccountStore((state) => ({
    hasAuth: state.hasAuth,
    setTimeOffset: state.setTimeOffset,
  }));
  const { publicWs, privateWs } = useWebSocketStore();
  const { mutateAsync: getListenKey } = useListenKey();
  const [isRealTimeConnectionLost, setRealTimeConnectionLost] = useState({
    private: false,
    public: false,
  });

  useEffect(() => {
    if (!publicWs) return;
    publicWs.attachOnConnect(() =>
      setRealTimeConnectionLost((prev) => ({ ...prev, public: false })),
    );
    const onDisconnect = (error?: string | ErrorCode) => {
      setRealTimeConnectionLost((prev) => ({ ...prev, public: true }));
      if (error) {
        logConsole(true, 'PublicWS Error', error);
      }
    };
    publicWs.attachOnDisconnect(onDisconnect, 1);
    // publicWs.attachOnError(onDisconnect);
  }, [publicWs]);

  useEffect(() => {
    if (!privateWs) return;
    privateWs.attachOnConnect(() =>
      setRealTimeConnectionLost((prev) => ({ ...prev, private: false })),
    );
    privateWs.attachOnDisconnect(() => {
      if (hasAuth) {
        setRealTimeConnectionLost((prev) => ({ ...prev, private: true }));
      }
    }, 1);
    privateWs.attachOnError((error) => {
      switch (error) {
        case WsErrorCode.LISTEN_KEY_NOT_FOUND:
        case WsErrorCode.LISTEN_KEY_EXPIRED:
          getListenKey();
          break;
      }
      logConsole(true, 'PrivateWS Error', error);
    });
    // privateWs.attachOnError(onDisconnect);
  }, [privateWs]);

  useEffect(() => {
    setTimeOffset(offset);
  }, [offset]);

  // const isMobile = MOBILE_PAGES.some((page) => pathname.startsWith(page));
  return (
    <ErrorBoundary>
      {/* {publicWs?.isReady() && (
        <Button
          className="absolute bottom-6 right-24 z-50"
          onClick={() => disconnectPublicWs(true)}
        >
          Disconnect Public WS
        </Button>
      )} */}
      <NavigationListener />
      <div className="flex h-full flex-col">
        {Object.values(isRealTimeConnectionLost).some(Boolean) && (
          <RealtimeConnectionLostBanner />
        )}
        {isSanctioned && <GeofenceBanner />}
        {/* {!isSystemClockAccurate && <SystemClockBanner />} */}
        <AnnouncementBanner />
        <Header />
        <main className="h-full">
          <Outlet />
        </main>
      </div>
    </ErrorBoundary>
  );
}

function NavigationListener() {
  const navigate = useNavigate();
  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent<{ pathname?: string; search?: string }>)
        .detail;
      if (!detail) return;
      const { pathname, search } = detail;
      navigate({
        pathname,
        search,
      });
    };

    window.addEventListener('app:navigate', handler);
    return () => window.removeEventListener('app:navigate', handler);
  }, []);
  return <></>;
}
